import Component from './personal-info-page';
export default Component;
